/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import ouiDom from '@goldwasserexchange/oui-dom';
import { useHookstate } from '@hookstate/core';
import { Trans } from '@lingui/macro';
import * as React from 'react';
import { Loader } from 'react-feather';
import { ForbiddenErrorMessage, SendMessageButtonContainer } from './components';

const sendMessageFormStyle: ouiStyle.InStyle = {
  textAlign: 'center',
  paddingTop: 'double',
};

const sendMessageFormCss = ouiStyle.makeCss(sendMessageFormStyle);

const sendMessageInputStyle: ouiStyle.InStyle = {
  widthLines: 17.5,
  marginHorizontal: 'auto',
  lines: 12,
  color: ouiStyle.Constants.Colors.accent,
  backgroundColor: ouiStyle.Constants.Colors.fade,
  padding: 'simple',
  borderRadius: 'rounded',
};

const sendMessageInputCss = ouiStyle.makeCss(sendMessageInputStyle);

export const SendMessageInput = (props: {
  initialContent: string,
  onSubmit: React.FormEventHandler<HTMLFormElement>,
  isLoading: boolean,
  orderForbidden: boolean,
}) => {
  const {
    initialContent,
    onSubmit,
    isLoading,
    orderForbidden,
  } = props;
  const messageContent = useHookstate(initialContent);
  return (
    <React.Fragment>
      {orderForbidden
        ? (
          <ForbiddenErrorMessage />
        )
        : null}
      <form
        css={sendMessageFormCss}
        onSubmit={onSubmit}
      >
        <textarea
          id="emailContent"
          name="emailContent"
          css={sendMessageInputCss}
          value={messageContent.get()}
          onChange={(e) => messageContent.set(e.target.value)}
        />
        <SendMessageButtonContainer>
          <ouiDom.Button.Button
            type="submit"
            disabled={isLoading}
            backgroundColor={ouiStyle.Constants.Colors.primary}
            color={ouiStyle.Constants.Colors.inverted}
            hoverBackgroundColor={ouiStyle.Constants.Colors.primaryShaded}
          >
            {!isLoading
              ? (
                <Trans>
                  Envoyer
                </Trans>
              )
              : <Loader size="1rem" /> }
          </ouiDom.Button.Button>
        </SendMessageButtonContainer>
      </form>
    </React.Fragment>
  );
};
